import { render, staticRenderFns } from "./EduExampaperCategory.vue?vue&type=template&id=b973e518&scoped=true&"
import script from "./EduExampaperCategory.vue?vue&type=script&lang=js&"
export * from "./EduExampaperCategory.vue?vue&type=script&lang=js&"
import style0 from "./EduExampaperCategory.vue?vue&type=style&index=0&id=b973e518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b973e518",
  null
  
)

export default component.exports